define('models/accounts/rebatesummary',[
    'backbone',
    'models/merchants/merchantgroups/merchantgroup_collection',
], function(Backbone, MerchantList){

    var RebateSummary = Backbone.Model.extend({
        url: function () {
            var url = pf.consumerURL + "/Rebates";

            if (this.limit != null) {
                url += "/" + this.limit;
            } else {
                url += "/" + 1;
            }

            return url;
        },
        initialize: function (options) {
            options = options || {};
            this.limit = options.limit;
        },
        parse: function (data) {
            var response = {};

            if(data){
                response.TotalRebates = data.TR;
                response.RebatesThisYear = data.RTY;
                response.RebatesThisMonth = data.RTM;
                response.RebatesThisWeek = data.RTW;
                response.LatestRebates = new MerchantList(data.M);
            }
            return response;
        },
    });
    return RebateSummary;
    
});
